// src/components/PartnersPicker/components/SearchField.tsx
import React from 'react';
import { MagnifyingGlass, X, SpinnerGap } from 'phosphor-react';
import { useTranslation } from 'react-i18next';
import * as S from '../styles';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  isSearching?: boolean;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  isSearching = false
}) => {
  const { t } = useTranslation();

  return (
    <S.SearchWrapper>
      <S.SearchIcon>
        {isSearching ? (
          <SpinnerGap weight="bold" className="spin-animation" />
        ) : (
          <MagnifyingGlass weight="bold" />
        )}
      </S.SearchIcon>
      <S.SearchInput
        type="text"
        placeholder={t('Search partners...')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Search partners"
      />
      {value && (
        <S.ClearButton
          onClick={() => onChange('')}
          aria-label="Clear search"
        >
          <X size={16} weight="bold" />
        </S.ClearButton>
      )}
    </S.SearchWrapper>
  );
};
